import { render } from "./ContactListItem.vue?vue&type=template&id=113b4808&scoped=true"
import script from "./ContactListItem.vue?vue&type=script&lang=js"
export * from "./ContactListItem.vue?vue&type=script&lang=js"

import "./ContactListItem.vue?vue&type=style&index=0&id=113b4808&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-113b4808"

export default script